import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Params,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { BookMeNowStoreService } from './book-me-now-store.service';
import { filter, mapTo, switchMap } from 'rxjs/operators';
import { durationStringToMinutes, MeetingType } from '@vendasta/meetings';

@Injectable({
  providedIn: 'root',
})
export class SkipToContactFormGuard {
  constructor(
    private readonly bookmenowService: BookMeNowStoreService,
    private readonly router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.helper(route.params, route.queryParams);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.helper(childRoute.params, childRoute.queryParams);
  }

  private helper(params: Params, queryParams: Params): Observable<boolean> {
    const meetingTypeSlug = params.meetingTypeId;
    const calendarId = params.calendarId;
    const startTime = queryParams.startTime;
    const startDate = new Date(startTime);
    if (
      !(
        meetingTypeSlug &&
        startTime &&
        startDate &&
        !isNaN(startDate.getTime()) &&
        typeof location !== 'undefined' &&
        location.pathname.endsWith(meetingTypeSlug)
      )
    ) {
      return of(true);
    }
    return this.bookmenowService.loadCalendar(calendarId).pipe(
      switchMap(() => this.bookmenowService.loadMeetingType(meetingTypeSlug)),
      filter<MeetingType>(Boolean),
      switchMap((mt) => {
        const minutes = durationStringToMinutes({ duration: mt.duration });
        const endDate = new Date(startDate.getTime() + minutes * 60000);
        this.bookmenowService.setSelectedTimeSlot({
          start: startDate,
          end: endDate,
        });
        this.router.navigate([`${location.pathname}/contact-form`], {
          queryParamsHandling: 'merge',
          queryParams,
        });
        return of(true);
      }),
      mapTo(true)
    );
  }
}
